import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';

import Home from './Pages/Home';
import About from './Pages/About';

// import Membership from './Pages/Membership';
import Contact from './Pages/Contact';

import Alumnimeet from './Pages/AlumniEngagementfolder/Alumnimeet';
import AlumsCare from './Pages/AlumniEngagementfolder/AlumsCare';
import SIG from './Pages/AlumniEngagementfolder/SIG';

import VAANI from './Pages/Alumnidevelopmentfolder/Vaani';
import Capacity from './Pages/Alumnidevelopmentfolder/Capacity';
import Collaboration from './Pages/Alumnidevelopmentfolder/Collaboration';
import Regional from './Pages/Alumnidevelopmentfolder/Regional';
import Promoting from './Pages/Alumnidevelopmentfolder/Promoting';
import Job from './Pages/Alumnidevelopmentfolder/Job';

import Photo from './Pages/MediaFolder/Photo';
import Video from './Pages/MediaFolder/Video';
import Reports from './Pages/MediaFolder/Reports';
import Print from './Pages/MediaFolder/print';
import Electronic from './Pages/MediaFolder/Electronic';
import Social from './Pages/MediaFolder/Social';
import PastEvents from './Pages/MediaFolder/Pastevents';

import Membership from './Pages/joinus/MembershipForm';
import Donation from './Pages/joinus/Donation';

import PersonDetails from './Pages/PersonDetails';

import Event from './Pages/Event/Event';

import Login from './components/login';
import SetPassword from './components/SetPassword';
import './App.css';

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        
        <Route path="/engagement/alumni-meet" element={<Alumnimeet />} />
        <Route path="/engagement/AlumsCare" element={<AlumsCare />} />
        <Route path="/engagement/sig" element={<SIG/>} />

        <Route path="/development/vaani" element={<VAANI />} />
        <Route path="/development/Capacity" element={<Capacity />} />
        <Route path="/development/Collaboration" element={<Collaboration />} />
        <Route path="/development/Regional" element={<Regional />} />
        <Route path="/development/Promoting" element={<Promoting />} />
        <Route path="/development/Job" element={<Job />} />

        <Route path="/media/Photo" element={<Photo />} />
        <Route path="/media/Video" element={<Video />} />
        <Route path="/media/Reports" element={<Reports />} />
        <Route path="/media/print" element={<Print />} />
        <Route path="/media/Electronic" element={<Electronic />} />
        <Route path="/media/Social" element={<Social />} />
        <Route path="/media/past-events" element={<PastEvents />} />
        
        <Route path="/membership" element={<Membership />} />
        <Route path="/donation" element={<Donation />} />

        <Route path="/joinus" element={<joinUs />} />
        <Route path="/joinus/membership" element={<Membership />} />
        <Route path="/joinus/donation" element={<Donation />} />

        <Route path="/Event" element={<Event />} />

        <Route path="/person-details/:name" element={<PersonDetails />} />

        <Route path="/contact" element={<Contact />} />

        <Route path="/about/*" element={<About />} />


        <Route path="/login" element={<Login />} />
        
        <Route path="/set-password" element={<SetPassword />} />
      </Routes>
    </Router>
  );
}

export default App;
